import { render, staticRenderFns } from "./MailConfiguration.vue?vue&type=template&id=07ee496b"
import script from "./MailConfiguration.vue?vue&type=script&lang=js"
export * from "./MailConfiguration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports